<form [formGroup]="createForm" class="form-validation" (ngSubmit)="onSubmit()" *ngIf="generalLang">
  <div class="modal-header">
    <h4 class="modal-title pull-left" style="text-transform: uppercase;">{{modalTitle}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <table  class="table table-striped table-hover table-bordered">
      <tbody>
        <tr>
          <td width="20%"> {{ generalLang.consultancyCode }}</td>
          <td>{{ record?.const_code }}</td>
        </tr>

        <tr>
          <td> {{ generalLang?.type }}</td>
          <td>{{ record?.type }}</td>
        </tr>

        <tr>
          <td>{{ generalLang?.date }}</td>
          <td>{{ record?.pro_date }}</td>
        </tr>

        <tr>
          <td> {{ generalLang?.topics }}</td>
          <td>{{ record?.topic }}</td>
        </tr>
        <tr>
          <td>{{ generalLang?.description }}</td>
          <td>{{ record?.discription }}</td>
        </tr>
        <tr>
          <td> {{ generalLang?.addresser }}</td>
          <td>{{ record?.addresser }}</td>
        </tr>
        <tr>
          <td>{{ generalLang?.addressee }}</td>
          <td>{{ record?.addressee }}</td>
        </tr>
        <tr>
          <td> {{generalLang.documentAttachment}}</td>
          <td>
            <div class="" formArrayName="timetable_link_uploaded">
              <div class="">
                <div class="" *ngFor="let image of timetable_link_uploaded().controls; let i=index">
                  <div class="col-sm-11">
                    <input type="hidden" class="form-control" formControlName="{{i}}">
                    <input type="hidden" class="filestyle" data-buttonText="Choose file" (change)="selectAttachment($event,i)"
                      value="{{image.value.split('/').pop()}}">
      
                    <!-- <a (click)="imagePreview(image.value)">{{image.value.split('/').pop()}}</a> -->
                    <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/consultancy/{{image.value.split('/').pop()}}"
                      target="_blank">{{image.value.split('/').pop()}}</a>
      
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>


      </tbody>
    </table>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="bsModalRef.hide()">{{ generalLang?.close }}</button>

  </div>
</form>

<ng-template #imagePreviewRef let-link='imageLink'>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Image Preview</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body section-spaces">
    <app-image-preview [imageUrl]="imageLink"></app-image-preview>
  </div>
</ng-template>